import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTemplate } from '../../../../state';

const TemplateTitleEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateTemplate({ templateTitle: event.target.value }));
  };

  return (
    <TextField
      label="Template Title"
      value={currentRecurringTask?.templateTitle || ''}
      onChange={handleChange}
      size="small"
      required
      fullWidth
      placeholder="Enter a descriptive title for this recurring task"
    />
  );
};

export default TemplateTitleEdit;
